function mediaslider(){
  var mediahero = document.querySelectorAll('.section-media-slider');   
  mediahero.forEach(function(heroClass){
    var dataloop = heroClass.dataset.loop;
    var dataautoplay = heroClass.dataset.autoplay;
    if(dataautoplay == 'false' || dataautoplay == false){
      var flky = new Flickity(heroClass, {
        contain: true,
        pageDots: false,
        wrapAround: dataloop
      });
    }else{
      var flky = new Flickity(heroClass, {
        contain: true,
        pageDots: false,
        wrapAround: dataloop,
        autoPlay: dataautoplay
      });
    }
  });
}
mediaslider();